import {
  IPlatformAPI,
  IWebStorage,
} from '@wix/native-components-infra/dist/src/types/types';
import { aMemoryStorage } from '@wix/native-components-infra/dist/src/memoryStorage/memoryStorage';
import { guid } from '../../lib/guid';

export const enum BICorrelationIdKey {
  SearchSuggestions = 'BICorrelationId:SearchSuggestions',
  SearchSubmit = 'BICorrelationId:SearchSubmit',
}

export function createBICorrelationId(): string {
  return guid();
}

export class BICorrelationIdStore {
  private readonly storage: IWebStorage;

  constructor(platformApi: IPlatformAPI) {
    // NOTE: storage could be not available in some browsers
    // https://sentry.io/organizations/wix_o/issues/1140629343/
    // https://sentry.io/organizations/wix_o/issues/1145676561/
    this.storage = [
      platformApi.storage.session,
      platformApi.storage.memory,
      aMemoryStorage,
    ].find(_storage => _storage && typeof _storage.getItem === 'function');
  }

  set(key: BICorrelationIdKey, correlationId: string): void {
    this.storage.setItem(key, correlationId);
  }

  get(key: BICorrelationIdKey): string {
    return this.storage.getItem(key);
  }

  has(key: BICorrelationIdKey): boolean {
    return this.storage.getItem(key) !== null;
  }
}
